import React, { useEffect } from "react";
import "../../assets/css/Modal.css";

interface ModalProps {
  visible: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

const Modal: React.FC<ModalProps> = ({ visible, onClose, children }) => {
  useEffect(() => {
    if (visible) {
      document.body.style.overflow = "hidden"; // Prevent background scrolling
    } else {
      document.body.style.overflow = "auto"; // Restore scrolling
    }

    return () => {
      document.body.style.overflow = "auto"; // Cleanup on unmount
    };
  }, [visible]);

  // When clicking outside the modal, call onClose()
  const handleOverlayClick = () => {
    onClose();
  };

  // Prevent the click event from bubbling up to the overlay
  const handleModalContainerClick = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  return (
    <div
      className={`modal-overlay ${visible ? "show" : ""}`}
      onClick={handleOverlayClick}
    >
      <div className="modal-container" onClick={handleModalContainerClick}>
        {children}
      </div>
    </div>
  );
};

export default Modal;
